export default {
  title: 'user',
  type: 'object',
  properties: {
    login: {
      type: 'string',
      title: 'Nazwa użytkownika',
      format: 'email',
      fieldRequired: true,
      validationMessages: {
        format: 'Login użytkownika musi być adresem e-mail'
      }
    },
    profile: {
      type: 'object',
      title: 'Profil',
      properties: {
        type: {
          title: 'Typ konta',
          type: 'number',
          fieldRequired: true
        },
        firstName: {
          title: 'Imię użytkownika',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        lastName: {
          title: 'Nazwisko użytkownika',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        pesel: {
          title: 'Pesel',
          type: 'string',
          format: 'pesel',
          fieldRequired: true,
          validationMessages: {
            format: 'Niepoprawny numer PESEL'
          }
        },
        email: {
          title: 'Adres e-mail',
          type: 'string',
          computed: true,
          calc: '$root.login'
        },
        phoneNumber: {
          title: 'Numer telefonu',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        confirmReason: {
          title: 'Powód akceptacji',
          type: 'string',
          fieldRequired: true
        },
        woj: {
          title: 'Województwo',
          type: 'string',
          fieldRequired: true
        },
        pow: {
          title: 'Powiat',
          type: 'string',
          fieldRequired: true
        },
        gmi: {
          title: 'Gmina',
          type: 'string',
          fieldRequired: true
        },
        terc: {
          title: 'Kod TERC',
          type: 'string',
          fieldRequired: true,
          minLength: 6
        },
        city: {
          title: 'Miejscowość',
          type: 'string',
          fieldRequired: true
        },
        simc: {
          title: 'Miejscowość',
          type: 'string',
          fieldRequired: true
        },
        street: {
          title: 'Ulica',
          type: 'string',
          fieldRequired: true
        },
        ulic: {
          title: 'Ulica',
          type: 'string',
          fieldRequired: true
        },
        postalCode: {
          title: 'Kod pocztowy',
          type: 'string',
          format: 'kod',
          fieldRequired: true,
          validationMessages: {
            format: 'Niepoprawny kod pocztowy'
          }
        },
        homeNumber: {
          title: 'Numer budynku',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        localNumber: {
          title: 'Numer lokalu',
          type: 'string',
          fieldRequired: false,
          maxLength: 500
        },
        mainImage: {
          title: 'Zdjęcie',
          type: 'number'
        },
        confirmReasonDescription: {
          title: 'Powód akceptacji dodatkowe informacje',
          type: 'string',
          fieldRequired: false,
          maxLength: 500
        }
      }
    }
  }
};
